import { auth } from '@src/plugins/Auth';

export default () => auth.login();
